import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getAddCommentList = createAsyncThunk(
  "addCommentList/getAddCommentList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/comment/create`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const addCommentSlice = createSlice({
  name: "addCommentList",
  initialState: {
    loading: false,
    addCommentData: null,
    error: null,
  },
  reducers: {
    ResetAddCommentState: (state) => {
      state.loading = false;
      state.addCommentData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAddCommentList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAddCommentList.fulfilled, (state, action) => {
        state.loading = false;
        state.addCommentData = action.payload;
      })
      .addCase(getAddCommentList.rejected, (state, action) => {
        state.loading = false;
        state.addCommentData = action.payload;
        state.error = action.payload;
      });
  },
});

export const { ResetAddCommentState } = addCommentSlice.actions;
export default addCommentSlice.reducer;
